/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  CREATE_EMPLOYEE = '[Admin] Create Employee',
  CREATE_EMPLOYEE_SUCCESS = '[Admin] Create Employee Success',
  CREATE_EMPLOYEE_FAILED = '[Admin] Create Employee Failed',
}

export const createEmployee = createAction(
  ActionTypes.CREATE_EMPLOYEE,
  props<{ data: any }>()
);

export const createEmployeeSuccess = createAction(
	ActionTypes.CREATE_EMPLOYEE_SUCCESS,
  props<{ data: any }>()
);

export const createEmployeeFailed = createAction(
  ActionTypes.CREATE_EMPLOYEE_FAILED,
  props<{ data: any }>()
);